import React from 'react';

const namesList = (names) => names.length < 3
  ? names.join(' and ')
  : `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;

export default function DailyHonors({ honors, games, viewerName, onDismiss }) {
  const dialog = React.useRef(null);
  const dismiss = React.useRef(null);
  const previousFocus = React.useRef(null);
  React.useEffect(() => {
    previousFocus.current = document.activeElement;
    dialog.current.showModal();
    dismiss.current.focus();
    return () => { previousFocus.current?.focus(); };
  }, []);
  const champions = honors.filter((player) => player.champion);
  const championNames = namesList(champions.map((player) => player.name));
  const personalHonor = honors.find((player) => player.name.toLocaleLowerCase() === viewerName.toLocaleLowerCase());
  const isSweep = champions[0].wins === 7;
  const headline = champions.length > 1
    ? `${champions.length} champions. ${champions.reduce((total, player) => total + player.wins, 0)} crowns.`
    : isSweep ? 'A clean sweep. All seven games!'
      : `${champions[0].wins === 3 ? 'Three' : champions[0].wins === 4 ? 'Four' : champions[0].wins === 5 ? 'Five' : 'Six'} crowns. One champion.`;
  return (
    <dialog ref={dialog} className="honors-dialog" aria-labelledby="honors-headline" aria-describedby="honors-proclamation" onCancel={(event) => { event.preventDefault(); onDismiss(); }}>
      <div className="honors-confetti" aria-hidden="true">{Array.from({ length: 24 }, (_, index) => <i key={index} style={{ '--piece': index }} />)}</div>
      <div className="honors-crown" aria-hidden="true">👑</div>
      <p className="honors-eyebrow">Yesterday’s {champions.length > 1 ? 'champions' : 'champion'}</p>
      <h2 id="honors-headline">{headline}</h2>
      <p id="honors-proclamation">{championNames} {champions.length > 1 ? 'share' : 'claims'} yesterday’s top honors{champions.length > 1 ? ` with ${champions[0].wins} victories each` : ` with ${champions[0].wins} victories`}. A day for the record books!</p>
      {personalHonor && <p className="honors-personal">{personalHonor.champion ? (champions.length > 1 ? 'You’re one of yesterday’s champions!' : 'You’re yesterday’s champion!') : 'A remarkable day!'} {personalHonor.wins === 7 ? 'You won every game. A clean sweep!' : `You earned ${personalHonor.title} honors.`}</p>}
      <ul className="honors-recipients">
        {honors.map((player) => <li key={player.name}>
          <div className="honors-recipient-heading"><strong>{player.name}</strong><span>{player.champion ? '👑 ' : ''}{player.title}</span></div>
          <p>{player.wins} wins · {namesList(player.games.map((key) => games.find((game) => game.key === key)?.name || key))}</p>
        </li>)}
      </ul>
      <button ref={dismiss} className="honors-dismiss" type="button" onClick={onDismiss}>Let’s play!</button>
    </dialog>
  );
}
